<script>

import Accordion from "primevue/accordion";

export default {

  extends: Accordion,
  methods: {

    getKey(tab, i) {

      if (tab.props.key !== null && typeof tab.props.key !== 'undefined')
        return tab.props.key;

      return (tab.props && tab.props.header) ? tab.props.header : i;
    },

  }

}

</script>